export const descriptionAlert = (
  <p>
    Please enter all the details and submit the data. After submission Passport
    request will go to higher officials approval and you can cancel it at any
    point of time before it gets approved by HR departments.
    <br />
    Each request will be monitored by HR & PRO department.
  </p>
);
